import styled from "styled-components";

const LinkText = styled.p`
  font-size: 22px;
  line-height: 26px;
  font-weight: 200;
  margin: 0;
  color: #000;

  @media (max-width: 1199px) {
    font-size: 17px;
    line-height: normal;
  }
  @media (max-width: 767px) {
    font-size: 15px;
  }
  @media (max-width: 575px) {
    font-size: 12px;
    background: #fff;
    padding: 2px 6px;
    font-weight: 400;
  }
`;
export default LinkText;
